import { observer } from 'mobx-react-lite'
import React from 'react'
import classNames from 'classnames'
import { Dropdown } from 'shared/ui'
import { EmptyItem } from 'widgets/SendFromMulti/ui/EmptyItem/EmptyItem'
import { SelectedItem } from 'widgets/SendFromMulti/ui/SelectedItem/SelectedItem'
import { useSendFromMultiContext } from 'widgets/SendFromMulti/context/context'
import { SendFromTriggerInnerContent } from 'widgets/SendFrom'
import styles from './styles.module.scss'

export type ITriggerProps = {
  emptyPlaceholder?: string
  selectedOptionsCount?: number
  isShowIcon?: boolean
  shouldShowSelectedItems?: boolean
  showNumbersCount?: boolean
  hideNumbers?: boolean
  triggerInnerContentClassName?: string
}

export const Trigger = observer(
  ({
    emptyPlaceholder = 'Select options',
    selectedOptionsCount = 3,
    isShowIcon = true,
    shouldShowSelectedItems = true,
    showNumbersCount = false,
    hideNumbers = false,
    triggerInnerContentClassName,
  }: ITriggerProps) => {
    const { loading, selectedDropdownItems } = useSendFromMultiContext()
    if (loading || !selectedDropdownItems.length) {
      return (
        <EmptyItem loading={loading} emptyPlaceholder={emptyPlaceholder} isShowIcon={isShowIcon} />
      )
    }

    const visibleItems = selectedDropdownItems.slice(0, selectedOptionsCount)
    const dropdownItems = selectedDropdownItems.slice(selectedOptionsCount)

    return (
      <div
        className={classNames(styles.trigger, {
          [styles.triggerOneRow]: selectedOptionsCount === 1,
        })}
      >
        {visibleItems.map((item) => (
          <SelectedItem
            key={item.id}
            item={item}
            showNumbersCount={showNumbersCount}
            hideNumbers={hideNumbers}
            triggerInnerContentClassName={triggerInnerContentClassName}
          />
        ))}
        {!!dropdownItems.length &&
          (shouldShowSelectedItems ? (
            <Dropdown
              ariaLabel={'ItemsWithCount'}
              triggerComponent={() => (
                <div className={styles.remainderCount}>+{dropdownItems.length}</div>
              )}
              items={dropdownItems.map((item) => ({
                id: item.id,
                label: item.label,
                labelContent: (
                  <div className={styles.item}>
                    <SendFromTriggerInnerContent item={item} hideNumbers={hideNumbers} />
                  </div>
                ),
              }))}
              placement='bottom-end'
            />
          ) : (
            <div className={styles.remainderCount}>+{dropdownItems.length}</div>
          ))}
      </div>
    )
  }
)
